var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aj-expander",style:('height:' + (_vm.expended ? _vm.openHeight : _vm.closeHeight) + 'px;')},[_c('div',{class:_vm.expended ? 'closeBtn' : 'openBtn',on:{"click":function($event){_vm.expended = !_vm.expended;}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }